<div class="auth-container d-flex py-13 flex-column align-items-center ">
  <div class="auth-content evisa-bg-blue-gradient rounded-5">
    <p class="common-container-heading text-center mb-0 p-3 linear-gradient-text mx-auto heading-2">
      <span class="text-blue-1 ibm-semibold">
        {{ authTitle | translate }}
      </span>
    </p>

    <div class="p-4 p-md-6 pt-3">
      <div class="visa-selector d-flex justify-content-evenly my-6"
        [class.d-none]="router.url.includes('/forgot-password')">
        @for (item of visaTypeList; track item.visaType) {
        <button class="visa-item d-flex flex-column align-items-center d-block"
          [ngClass]="selectedVisaType === item.visaType ? 'selected' : ''" (click)="onSelectVisaType(item.visaType)"
          [disabled]="router.url.includes('/sign-up') && [visaTypes.BUSINESS, visaTypes.GOVERNMENT].includes(item.visaType)">
          <div class="icon d-flex justify-content-center p-3 align-items-center">
            <img class="evisa-white-filter" [src]="item.visaTypeImage" loading="eager" decoding="async" />
          </div>
          <p class="mb-0 text-center mt-2 ibm-semibold text-5 text-blue-1 d-md-none">
            {{ item.visaTypename | translate }}
          </p>
          <p class="mb-0 text-center mt-2 ibm-semibold text-3 text-blue-1 d-none d-md-block">
            {{ item.visaTypename | translate }}
          </p>
        </button>
        }
      </div>

      @switch (true) {
      @case (router.url.includes(routeType.BUSINESS_SIGN_IN)) {
      <app-business-sign-in />
      }
      @case (router.url.includes(routeType.GOVERNMENT_SIGN_IN)) {
      <app-government-sign-in />
      }
      @case (router.url.includes(routeType.BUSINESS_PAYMENT_SIGN_IN)) {
      <app-business-sign-in />
      }
      @case (router.url.includes(routeType.GOVERNMENT_PAYMENT_SIGN_IN)) {
      <app-government-sign-in />
      }
      @case (router.url.includes(routeType.FAMILY_SIGN_IN)) {
      <app-family-sign-in />
      }
      @case (router.url.includes(routeType.FAMILY_PAYMENT_SIGN_IN)) {
      <app-family-sign-in />
      }
      @case (router.url.includes(routeType.FAMILY_SIGN_UP)) {
      <app-family-sign-up />
      }
      @case (router.url.includes('/sign-in')) {
      <app-sign-in ngSkipHydration></app-sign-in>
      }
      @case (router.url.includes('/evisa-payment')) {
      <app-sign-in ngSkipHydration></app-sign-in>
      }
      @case (router.url.includes('/sign-up')) {
      <app-sign-up ngSkipHydration></app-sign-up>
      }
      @case (router.url.includes('/forgot-password')) {
      <app-forgot-password ngSkipHydration></app-forgot-password>
      }
      }
    </div>
  </div>
</div>